export default __webpack_public_path__ + "images/bgflt2.17eda9e.jpg";